import { Facebook, Instagram, LayoutList, type LucideIcon, PlugZap, Send } from 'lucide-react'
import * as m from '~/paraglide/messages'

export type CrosspostingToolKey = 'connect' | 'facebook' | 'instagram' | 'cross-post' | 'overview'

interface CrosspostingToolMeta {
  icon: LucideIcon
  title: () => string
  description: () => string
}

export const CROSSPOSTING_TOOL_META: Record<CrosspostingToolKey, CrosspostingToolMeta> = {
  connect: {
    icon: PlugZap,
    title: m.crosspostingConnectTitle,
    description: m.crosspostingConnectDescription,
  },
  facebook: {
    icon: Facebook,
    title: m.crosspostingFacebookTitle,
    description: m.crosspostingFacebookDescription,
  },
  instagram: {
    icon: Instagram,
    title: m.crosspostingInstagramTitle,
    description: m.crosspostingInstagramDescription,
  },
  'cross-post': {
    icon: Send,
    title: m.crosspostingCrossPostTitle,
    description: m.crosspostingCrossPostDescription,
  },
  overview: {
    icon: LayoutList,
    title: m.crosspostingOverviewTitle,
    description: m.crosspostingOverviewDescription,
  },
}
